import { render, staticRenderFns } from "./RaPagination.vue?vue&type=template&id=140f3db2"
import script from "./RaPagination.vue?vue&type=script&lang=js"
export * from "./RaPagination.vue?vue&type=script&lang=js"
import style0 from "./RaPagination.vue?vue&type=style&index=0&id=140f3db2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports